import {
	API_GET_CONNECTED_USERS_WS,
	API_POST_DISCONNECTED_USERS_WS
} from 'actions/websocket';
let hostWS = null
export const wsConnect = host => {
    if (!hostWS && host) 
        hostWS = host;
    return({ type: 'WS_CONNECT', host: host ? host : hostWS })
};
export const wsConnecting = host => ({ type: 'WS_CONNECTING', host });
export const wsConnected = host => ({ type: 'WS_CONNECTED', host });
export const wsDisconnect = host => ({ type: 'WS_DISCONNECT', host });
export const wsDisconnected = host => ({ type: 'WS_DISCONNECTED', host });
export const wsNewMessage = message => ({ type: 'NEW_MESSAGE', msg: message})

export function getConnectedUsersWS() {
	return {
		type: API_GET_CONNECTED_USERS_WS,
		payload: {
			request: {
				url: `/usersAlive`
			}
		}
	};
}

export function disconnectAllUsersWS(){
	return {
		type: API_POST_DISCONNECTED_USERS_WS,
		payload: {
			request: {
				url: `/usersStop`,
				method: 'POST',
			}
		}
	};
}
